<template>
  <div
    :ref="`product-${product.id}`"
    :class="product.className"
    class="detail-product__wrapper"
  >
    <div class="detail-product__container">
      <div class="detail-product__image-wrapper">
        <img
          :src="product.image"
          :alt="product.name"
          class="detail-product__image"
        >
        <div class="detail-product__text">
          <div class="detail-product__name">
            {{ product.name }}
          </div>
          <div class="detail-product__type">
            {{ product.type }}
          </div>
          <div
            v-if="product.addition"
            class="detail-product__addition"
          >
            {{ product.addition }}
          </div>
          <div
            class="detail-product__composition-table"
          >
            <div
              v-for="(el, index) in product.composition"
              :key="index"
              class="composition-table__el"
            >
              {{ el }}
            </div>
          </div>
          <div
            v-if="product.advantages"
            class="detail-product__advantages"
          >
            <div class="advantages__check" />
            {{ product.advantages }}
          </div>
        </div>
      </div>
    </div>
    <div class="detail-product__container-advantages">
      <div class="advantages__block">
        <span class="advantages__text">
          suitable for vegans
        </span>
      </div>
      <div class="advantages__block advantages__block--carbs">
        <span class="advantages__text">
          {{ product.carbs }}
        </span>
      </div>
      <div class="advantages__block advantages__block--calories">
        <img
          v-if="product.advImage"
          :src="product.advImage"
          :alt="product.name"
          class="advantages__image"
        >
        <span class="advantages__text">
          {{ product.calories }}
        </span>
      </div>
      <div class="advantages__block advantages__block--sodium">
        <span class="advantages__text">
          {{ product.sodium }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DetailProductComponent',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style
  lang="scss"
  scoped
>
  .detail-product {
    &__wrapper {
      width: 100%;

      &.mint {
        .detail-product__container {
          background: url(/images/Lime-desktop-v2.jpg);
          -webkit-background-size: cover;
          background-size: cover;
          padding: 83px 0;

          @include respond-to(tablet) {
            padding: 37px 0 80px;
          }
        }

        .advantages {
          &__block {
            &:first-child {
              background: $theme-color-first-product-block-bg-mint;
            }

            &:nth-child(2) {
              background: $theme-color-second-product-block-bg-mint;
            }

            &:last-child {
              background: $theme-color-forth-product-block-bg-mint;
            }
          }
        }
      }

      &.cake, &.berry {
        .detail-product {
          &__container {
            padding: 120px 0;

            @include respond-to(tablet) {
              padding: 65px 0;
            }
          }

          &__name {
            color: $theme-color-text-cake;
          }

          &__text {
            color: $theme-color-accent;
          }

          &__composition-table {
            border-color: $theme-color-accent;
          }
        }

        .composition-table {
          &__el {
            border-color: $theme-color-accent;
          }
        }

        .advantages {
          &__check {
            border-color: $theme-color-text-mint;
          }

          &__block {
            &:first-child {
              background: $theme-color-first-product-block-bg-cake;
            }

            &:nth-child(2) {
              background: $theme-color-second-product-block-bg-cake;
            }

            &:nth-child(3) {
              background: $theme-color-third-product-block-bg-cake;
            }

            &:last-child {
              background: $theme-color-forth-product-block-bg-cake;
            }
          }
        }
      }

      &.apple {
        .detail-product__container {
          background: url('/images/Apple-desktop-v2.jpg');
          -webkit-background-size: cover;
          background-size: cover;
          padding: 161px 0 125px;

          @include respond-to(tablet) {
            padding: 70px 0 60px;
          }
        }

        .advantages {
          &__block {
            &:first-child {
              background: $theme-color-first-product-block-bg-apple;
            }

            &:nth-child(2) {
              background: $theme-color-second-product-block-bg-apple;
            }

            &:last-child {
              background: $theme-color-forth-product-block-bg-apple;
            }
          }
        }
      }

      &.berry {
        .detail-product {
          &__name {
            color: $theme-color-text-berry;
          }
        }

        .advantages {
          &__block {
            &:first-child {
              background: $theme-color-first-product-block-bg-berry;
            }

            &:nth-child(2) {
              background: $theme-color-second-product-block-bg-berry;
            }

            &:nth-child(3) {
              background: $theme-color-third-product-block-bg-berry;
            }

            &:last-child {
              background: $theme-color-forth-product-block-bg-berry;
            }
          }
        }
      }

      &.revert {
        .detail-product {
          &__image-wrapper {
            flex-direction: row-reverse;

            @include respond-to(tablet) {
              margin-right: 10%;
              margin-left: 0;
            }

            @include respond-to(mobile) {
              margin-right: 0;
            }
          }

          &__text {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            text-align: right;
            margin: 50px -60% 0 0;
          }
        }
      }
    }

    &__container {
      max-width: 1600px;
      display: flex;
      justify-content: center;
      margin: 0 auto;
    }

    &__image-wrapper {
      max-width: 650px;
      display: flex;
      align-items: center;

      @include respond-to(tablet) {
        max-width: 70%;
        margin-left: 10%;
      }

      @include respond-to(mobile) {
        margin-left: 0;
        max-width: 80%;
      }
    }

    &__image {
      width: 100%;
    }

    &__text {
      color: $theme-color-light;
      margin: 50px 0 0 -60%;
      flex: 0 0 auto;
      max-width: 370px;

      @include respond-to(tablet-small) {
        max-width: 71%;
      }

      @include respond-to(mobile) {
        max-width: 171px;
        margin-top: 30px;
      }
    }

    &__name {
      font-size: 1.35em;
      margin-bottom: 17px;

      @include respond-to(tablet-small) {
        font-size: 1em;
        margin-bottom: 7px;
      }

      @include respond-to(mobile) {
        font-size: 0.6em;
      }
    }

    &__type {
      font-size: 6.06em;
      max-width: 220px;
      line-height: 0.8;
      letter-spacing: -1px;

      @include respond-to(tablet-small) {
        font-size: 3.5em;
        max-width: 150px;
      }

      @include respond-to(mobile) {
        font-size: 2.75em;
        letter-spacing: -0.4px;
        max-width: 98px;
      }
    }

    &__addition {
      font-size: 1.35em;
      margin-bottom: 18px;

      @include respond-to(tablet-small) {
        font-size: 1em;
        margin-bottom: 8px;
      }

      @include respond-to(mobile) {
        font-size: 0.6em;
        letter-spacing: -0.4px;
      }
    }

    &__composition-table {
      display: flex;
      border: 2px solid $theme-color-light;
      margin-bottom: 11px;

      @include respond-to(mobile) {
        font-size: 0.44em;
        letter-spacing: 0.1px;
        border-width: 1px;
        margin-bottom: 0;
        max-width: 100%;
      }
    }

    &__advantages {
      font-family: Montserrat;
      font-size: 0.7em;
      line-height: 1.81;
      letter-spacing: 0.3px;
      font-weight: 500;

      @include respond-to(mobile) {
        font-size: 0.5em;
        letter-spacing: 0.1px;
      }
    }

    &__container-advantages {
      height: 184px;
      width: 100%;
      max-width: 1600px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      @include respond-to(desktop-small) {
        height: 150px;
      }

      @include respond-to(tablet) {
        height: 120px;
      }

      @include respond-to(mobile) {
        flex-wrap: wrap;
        height: auto;
      }
    }
  }

  .composition-table {
    &__el {
      border-right: 2px solid $theme-color-light;
      font-size: 0.97em;
      padding: 13px 11px 10px;

      @include respond-to(tablet-small) {
        padding: 5px 5px 2px;
        font-size: 1.2em;
      }

      @include respond-to(mobile) {
        border-width: 1px;
        padding: 5px 2px 2px;
      }

      &:last-of-type {
        border-right: 0;
      }
    }
  }

  .advantages {
    &__check {
      display: inline-block;
      width: 4px;
      height: 9px;
      margin: 0px 3px;
      border: solid $theme-color-light;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);

      @include respond-to(mobile) {
        width: 3px;
        height: 6px;
        border-width: 0 1px 1px 0;
      }
    }

    &__block {
      display: flex;
      align-items: flex-end;
      padding: 26px 23px;
      box-sizing: border-box;
      width: 25%;
      color: $theme-color-light;
      position: relative;
      overflow: hidden;

      @include respond-to(mobile) {
        width: 50%;
        height: 95px;
      }
    }

    &__image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    &__text {
      position: relative;
      z-index: 1;
      font-size: 2.25em;
      max-width: 145px;
      line-height: 0.97;
      letter-spacing: -0.4px;
      font-family: Oswald;
      font-weight: bold;
      text-transform: uppercase;

      @include respond-to(tablet) {
        font-size: 1.5em;
        max-width: 115px;
        letter-spacing: -0.2px;
      }

      @include respond-to(mobile) {
        font-size: 1.15em;
        max-width: 88px;
      }
    }
  }
</style>
